module.exports = __webpack_public_path__ + "img/water11.d754785e.jpg";